module.exports = __webpack_public_path__ + "img/violet_108.35248bf1.png";